import { useState, useEffect } from 'react';

const navItems = [
  { label: '設備', href: '#equipment' },
  { label: '料金', href: '#pricing' },
  { label: 'アクセス', href: '#access' },
  { label: 'お店ルール', href: '#rules' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const scrollTo = (href: string) => {
    const el = document.querySelector(href);

    if (el) {
      el.scrollIntoView({
        behavior: 'smooth',
      });
    }

    setMenuOpen(false);
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-400 ${
        scrolled
          ? 'bg-[#0a0e1a]/95 backdrop-blur-md border-b border-white/10'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-6xl mx-auto px-4 sm:px-6 h-16 flex items-center justify-between">

        {/* ロゴ */}
        <a
          href="#"
          onClick={(e) => {
            e.preventDefault();

            window.scrollTo({
              top: 0,
              behavior: 'smooth',
            });
          }}
          className="flex items-center cursor-pointer"
        >
          <img
            src="/favicon.png"
            alt="デュエル ロゴ"
            className="h-10 w-10 rounded-full object-cover"
          />
        </a>

        {/* PCメニュー */}
        <nav className="hidden md:flex items-center gap-8">

          {navItems.map((item) => (
            <a
              key={item.href}
              href={item.href}
              onClick={(e) => {
                e.preventDefault();
                scrollTo(item.href);
              }}
              className="text-white/75 hover:text-[#d4af37] transition-colors duration-200 text-sm font-medium tracking-wider cursor-pointer whitespace-nowrap font-noto"
            >
              {item.label}
            </a>
          ))}

          {/* ポーカーガイド */}
          <a
            href="/rules"
            className="text-white/75 hover:text-[#d4af37] transition-colors duration-200 text-sm font-medium tracking-wider cursor-pointer whitespace-nowrap font-noto"
          >
            ポーカーガイド
          </a>

          {/* 予約 */}
          <a
            href="https://upnow.jp/duel"
            target="_blank"
            rel="noopener noreferrer"
            className="px-5 py-2 bg-[#d4af37] text-black text-sm font-bold rounded-full hover:bg-[#c9a227] transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            今すぐ予約（登録不要）
          </a>

        </nav>

        {/* スマホ ハンバーガー */}
        <button
          className="md:hidden w-10 h-10 flex flex-col items-center justify-center gap-1.5 cursor-pointer"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="メニューを開く"
        >
          <span
            className={`w-6 h-0.5 bg-white transition-all duration-300 origin-center ${
              menuOpen ? 'rotate-45 translate-y-2' : ''
            }`}
          />

          <span
            className={`w-6 h-0.5 bg-white transition-all duration-300 ${
              menuOpen ? 'opacity-0 scale-x-0' : ''
            }`}
          />

          <span
            className={`w-6 h-0.5 bg-white transition-all duration-300 origin-center ${
              menuOpen ? '-rotate-45 -translate-y-2' : ''
            }`}
          />
        </button>
      </div>

      {/* スマホメニュー */}
      <div
        className={`md:hidden overflow-hidden transition-all duration-300 ${
          menuOpen ? 'max-h-[500px]' : 'max-h-0'
        } bg-[#0a0e1a]/98 backdrop-blur-md border-t border-white/10`}
      >
        <nav className="flex flex-col px-6 py-4 gap-1">

          {navItems.map((item) => (
            <a
              key={item.href}
              href={item.href}
              onClick={(e) => {
                e.preventDefault();
                scrollTo(item.href);
              }}
              className="text-white/80 hover:text-[#d4af37] text-base font-medium py-3 border-b border-white/10 cursor-pointer transition-colors"
            >
              {item.label}
            </a>
          ))}

          <a
            href="/rules"
            onClick={() => setMenuOpen(false)}
            className="text-white/80 hover:text-[#d4af37] text-base font-medium py-3 border-b border-white/10 cursor-pointer transition-colors"
          >
            ポーカーガイド
          </a>

          <a
            href="https://upnow.jp/duel"
            target="_blank"
            rel="noopener noreferrer"
            className="mt-4 py-3 bg-[#d4af37] text-black text-sm font-bold rounded-full text-center cursor-pointer whitespace-nowrap"
          >
            今すぐ予約（登録不要）
          </a>

        </nav>
      </div>
    </header>
  );
}